export const zIndexes = {
  normal: 1,
  overlay: 2,
  popup: 5,
};
